import { ReportTypeEnum } from '@unified-ui/shared/data-store';

export enum TabTypeEnum {
    Home,
    Report,
    Dashboard
}

export interface ITabReport {
    id?: string;
    name: string;
    description?: string;
    shared: boolean;
    type: ReportTypeEnum;
}

export interface ITabDashboard {
    name: string;
    description?: string;
    shared?: boolean;
    type?: ReportTypeEnum; // TODO: Not needed
}
// Base for all the tabs either dashboard or reports
export interface IBaseTab<T extends ITabReport | ITabDashboard> {
    tabId: string;
    content: T;
    tabType: TabTypeEnum;
    validator?: unknown; // make this a function
    closeable: boolean; // in case we check if the report has unsaved changes and should be warned on closing
    icon: string;
}

export interface ITabInfo {
    name: string;
    unsaved: boolean;
    index: number;
    toClose: boolean;
    invalid: boolean; // used to mark tab/report invalid when data isn't loaded
    id: string;
}
